import { DocumentationTabTypes } from '../../types/enums/DocumentationTabTypes';
import { PanelType } from '../panels/types';
import { ConfigurationType, ConfigurationTypesWithIcon } from './dependencies/types';
import { AutomationType } from '../../types/enums/AutomationType';

export type AutomationStructureWithParentType = AutomationStructureNew & {
  parentType: ConfigurationType;
};

export const documentationPanelType: PanelType = {
  name: 'documentation',
  location: 'left',
};

export type SweepElementTypes =
  | ConfigurationType.sweepAutomation
  | ConfigurationType.sweepAssignment
  | ConfigurationType.sweepScheduledAssignment
  | ConfigurationType.sweepAlert
  | ConfigurationType.sweepMatching
  | ConfigurationType.sweepDedupe
  | ConfigurationType.rollups;

export const automationTypeToSweepElementType = (
  automationType: AutomationType,
): ConfigurationTypesWithIcon => {
  switch (automationType) {
    case AutomationType.Default:
      return ConfigurationType.sweepAutomation;
    case AutomationType.Assignment:
      return ConfigurationType.sweepAssignment;
    case AutomationType.ScheduledAssignment:
      return ConfigurationType.sweepScheduledAssignment;
    case AutomationType.Alert:
      return ConfigurationType.sweepAlert;
    case AutomationType.Dedupe:
      return ConfigurationType.sweepDedupe;
    case AutomationType.Matching:
      return ConfigurationType.sweepMatching;
    default:
      return ConfigurationType.sweepAutomation;
  }
};

export type SelectedObjectListElements = {
  value: string;
  label: string;
  badgeLabel?: number;
}[];

export type RecordTypesLabelsAndStepsByNameAndObjectName = {
  [objectName: string]: {
    [rtName: string]: {
      label: string;
      leadingFieldName: string;
      steps: { value: string; label: string }[];
    };
  };
};

export interface ObjectWithPills extends ObjectTypeName {
  pills?: {
    [key in DocumentationTabTypes]: number;
  };
}

export enum SubPageTypes {
  objects = 'objects',
  tags = 'tags',
  users = 'users',
}

export enum DocumentationPageType {
  metadataTypes = 'metadataTypes',
  tagsAndUsers = 'tagsAndUsers',
  universalSearch = 'universalSearch',
}
